export const DEFAULT_HANDOFF_KEYWORDS = ['representante', 'humano', 'persona'];

export function formatCustomerPhone(phone: string): string {
  return phone.startsWith('+') ? phone : `+${phone}`;
}

export function getCustomerDisplayLabel(
  name: string | null | undefined,
  phone: string,
): string {
  return name?.trim() || formatCustomerPhone(phone);
}
